import React, { useRef } from 'react';
import './chapters.scss';
import Chapter1 from './Chapter1';
import Chapter2 from './Chapter2';
import Chapter3 from './Chapter3';
import Chapter4 from './Chapter4';
import Chapter5 from './Chapter5';
import Chapter6 from './Chapter6';
import Chapter7 from './Chapter7';
import InlinePhotos from '../InlinePhotos/InlinePhotos';
import Panelists from '../Panelists/Panelists';

function Chapters() {
  const inline1Ref = useRef();
  const inline4Ref = useRef();
  const inline5Ref = useRef();
  const inline6Ref = useRef();

  return (
    <section className="chapters">
      <Chapter1 />
      <Panelists />
      <Chapter2 />
      <InlinePhotos index={1} inlineRef={inline1Ref} />
      <Chapter3 />
      <InlinePhotos index={4} inlineRef={inline4Ref} />
      <Chapter4 />
      <InlinePhotos index={5} inlineRef={inline5Ref} />
      <Chapter5 />
      <InlinePhotos index={6} inlineRef={inline6Ref} />
      <Chapter6 />
      <Chapter7 />
    </section>
  );
}

export default Chapters;
